import { ContentProps } from '@helper/util/landing/types'

import Container from '@/landing/component/container'
import Heading from '@/landing/component/heading'

import Term from '@/landing/template/term/Content'

type Props = {
    contents: ContentProps;
}

const Landing = ({ contents }:Props) => {
  const { tacLabel, tacCaption } = contents
  return (
        <Container>
            <Heading caption={tacCaption} label={tacLabel} />
            <Term contents={contents} />
        </Container>
  )
}

export default Landing
